import { moment } from '@lib/moment';
import { FILTER_TYPE, IFilterType, INotification } from './notification.interface';

export const customLocaleKey = 'notification-item-locale';

export const mockNotifications: INotification[] = generateMockNotification();
export const perPage = 20;

export const filters: IFilterType[] = [
  {
    id: FILTER_TYPE.ALL,
    text: $localize`All Notifications`,
    hidePriority: false,
    params: {
      per_page: perPage,
      page_no: 1,
    },
    notificationIds: new Set<number>(),
    hasReceivedInitialData: false,
    isFullyLoaded: false,
  },
  {
    id: FILTER_TYPE.IMPORTANT,
    text: $localize`Important`,
    hidePriority: true,
    params: {
      per_page: perPage,
      page_no: 1,
      important: true,
    },
    notificationIds: new Set<number>(),
    hasReceivedInitialData: false,
    isFullyLoaded: false,
  },
];

function generateMockNotification() {
  const mockData: INotification[] = [];
  for (let i = 0; i <= 10; ++i) {
    mockData.push({
      id: i,
      read: true,
      seen: true,
      priority: false,
      text: 'Lorem ipsum dolor sit amet',
      subtext: null,
      type: 'Type',
      createdAt: moment(new Date('2021-01-01')),
      action: {
        redirectUri: '',
      },
    });
  }
  return mockData;
}
